<template>
  <div class="service-notifications">
    <service-header :signedIn="signedInUser !== null"/>
    <section class="heading">
      <h2>お知らせ</h2>
    </section>
    <section class="body">
      <b-container fluid>
        <b-row class="notifications-row">
          <b-col
            v-for="systemNotification of systemNotifications"
            :key="systemNotification.id"
            cols="12"
            md="6"
            lg="4"
          >
            <div
              class="notification-wrapper"
              @click="onClickSystemNotification(systemNotification.id)"
            >
              <img :src="systemNotification.thumbnail.url || require('@/assets/images/service/notification_thumbnail_default.png')">
              <div class="title">{{ systemNotification.title }}</div>
              <div class="published-at">{{ systemNotification.publishedAt | moment('YYYY.MM.DD') }}</div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="d-flex justify-content-center align-items-center mt-2">
              <proa-pagination :pagination="pagination" @changePage="changePage"/>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <service-footer
      :signedIn="signedInUser !== null"
      :route="$route.name"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SystemNotification from '@/store/models/SystemNotification'

import ServiceHeader from '@/components/molecules/service/ServiceHeader.vue'
import ServiceFooter from '@/components/molecules/service/ServiceFooter.vue'

export default {
  name: 'IndexNotifications',
  components: {
    ServiceHeader,
    ServiceFooter
  },
  computed: {
    systemNotifications: () => SystemNotification.query().orderBy('publishedAt', 'desc').get(),
    ...mapGetters({
      httpRequesting: 'httpRequesting',
      signedInUser: 'auth/signedInUser',
      pagination: 'entities/systemNotifications/pagination'
    })
  },
  methods: {
    async changePage(page) {
      await this.apiGetSystemNotifications({
        page: page
      })
      window.scrollTo({ top: 0 })
    },
    onClickSystemNotification: function(id) {
      this.$router.push({ name: 'showServiceNotifications', params: { id: id } })
    },
    ...mapActions({
      apiGetSystemNotifications: 'entities/systemNotifications/index'
    })
  },
  created() {
    this.apiGetSystemNotifications()
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.service-notifications {
  width: 100%;
  background-color: white;

  section {
    overflow-x: auto;

    &.body {
      margin-bottom: 200px;
    }
  }

  .heading {
    padding: 80px 20px 40px 20px;

    @include mq(md) {
      padding: 130px 20px 100px 20px;
    }

    h2 {
      text-align: center;
      font-size: 26px;
      font-weight: 600;
      line-height: 1.3;
      margin-bottom: 60px;

      @include mq(sm) {
        font-size: 32px;
      }
    }
  }

  .notifications-row {
    max-width: 1100px;
    margin: 0 auto;
  }

  .notification-wrapper {
    width: 320px;
    margin: auto;
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }

    img {
      width: 320px;
      height: 160px;
      border: 1px solid $light-border-color;
    }

    .title {
      font-size: 15px;
      font-weight: 600;
      line-height: 1.6;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    img, .title {
      margin-bottom: 20px;
    }

    .published-at {
      font-size: 15px;
      color: $service-primary-color;
      margin-bottom: 30px;
    }
  }
}
</style>
